import React from 'react';
import { useAddCardModal } from './useAddCardModal';
import { AddCardModalView } from './AddCardModalView';
import { AuthAndCardModal } from '../authAndCardModal';
import { Wallet } from '../../../api';

type AddCardModalProps = {
    open: boolean;
    onClose: () => void;
    onAddWallet?: (newWallet: Wallet) => void;
};

export const AddCardModal: React.FC<AddCardModalProps> = ({
    open,
    onClose,
    onAddWallet,
}) => {
    const modalState = useAddCardModal(onClose, onAddWallet);

    return (
        <AuthAndCardModal
            onClose={(_, reason) => {
                if (reason === 'backdropClick') return;
                modalState.handleClose();
            }}
            onBack={modalState.onBack}
            onCloseClick={modalState.handleClose}
            open={open}
        >
            <AddCardModalView {...modalState} />
        </AuthAndCardModal>
    );
};
